import classes from './TeamSelectorHeader.module.css';
import { Label } from '../Label/Label.tsx';
import { useId } from 'react';
import { useGetTeamsQuery } from '../../hooks';
import { useSelectedUnitContext } from '../../contexts/selectedUnitContext.tsx';
import { GhostLoader } from '../GhostLoader';
import { useTabletAndDownQuery } from '../../hooks/useTabletAndDownQuery.ts';
import cn from 'classnames';
import { SurveyFormCardUtils } from '../../utils/SurveyFormCardUtils/SurveyFormCard.utils.ts';
import { useTranslation } from 'react-i18next';

export const TeamSelectorHeader = () => {
  const { t } = useTranslation();
  const id = useId();
  const { setSelectedTeamId, selectedTeamId } = useSelectedUnitContext();
  const isTabletAndDown = useTabletAndDownQuery();
  const { data: teams, isLoading: isLoadingTeams } = useGetTeamsQuery();

  return (
    <div className={classes.container} data-print="false">
      {isLoadingTeams ? (
        <div
          className={cn(classes.selectorContainer, {
            [classes.selectorContainerMobile]: isTabletAndDown,
          })}
        >
          <GhostLoader style={{ height: 15, width: '30%', marginBottom: 4 }} />
          <GhostLoader style={{ height: 40, width: '100%' }} />
        </div>
      ) : (
        <div
          className={cn(classes.selectorContainer, {
            [classes.selectorContainerMobile]: isTabletAndDown,
          })}
        >
          <Label label={t('teamSelector.selectTeam')} htmlFor={id} size="md" />
          <select
            id={id}
            className={classes.selector}
            value={selectedTeamId || ''}
            onChange={(event) => {
              SurveyFormCardUtils.removeAllSessionKeys();
              setSelectedTeamId(parseInt(event.currentTarget.value, 10));
            }}
          >
            <option disabled value="">
              {t('teamSelector.selectATeam')}
            </option>
            {teams?.map((team) => (
              <option key={team.id} value={team.id}>
                {team.name}
              </option>
            ))}
          </select>
        </div>
      )}
    </div>
  );
};
